<template>
    <div class="private-data">
        <b-row>
            <b-col cols="12">
                <b-row>
                    <b-col md="6">
                        <service-supplier-price-details
                            :supplier_price_details="supplier_price_details"
                            :service_index="service_index"
                            @supplier_price_details_updated="(value) => {
                                this.supplier_price_details = value
                                this.update_private_data()
                            }"
                        />
                    </b-col>
                </b-row>

                <b-row class="mt-2">
                    <b-col md="2">
                        <div class="private-data--price">
                            <b-form-group id="private_price" label="Totale costi netti" label-for="supplier_price">
                                <b-form-input
                                    type="number"
                                    min="0"
                                    size="sm"
                                    id="supplier_price"
                                    v-model="supplier_price"
                                    placeholder="totale costi netti"
                                    required
                                    @input="update_private_data"
                                ></b-form-input>
                            </b-form-group>
                        </div>
                    </b-col>

                    <b-col md="2">
                        <div class="private-data--supplier" v-if="supplier">
                            <b-form-group id="supplier" label="Fornitore" label-for="supplier">
                                <b-form-input
                                    size="sm"
                                    id="supplier"
                                    v-model="supplier"
                                    placeholder="fornitore"
                                    required
                                    disabled
                                    @input="update_private_data"
                                ></b-form-input>
                            </b-form-group>
                        </div>
                    </b-col>

                    <b-col md="2" offset-md="1">
                        <div class="private-data--supplier-quote-id" v-if="supplier_quote_id">
                            <b-form-group id="supplier" label="Fornitore ID preventivo" label-for="supplier_quote_id">
                                <b-form-input
                                    size="sm"
                                    id="supplier_quote_id"
                                    v-model="supplier_quote_id"
                                    placeholder="id preventivo"
                                    required
                                    disabled
                                    @input="update_private_data"
                                ></b-form-input>
                            </b-form-group>
                        </div>                    
                    </b-col>

                    <b-col md="2" offset-md="1">
                        <div class="private-data--notes">
                            <b-form-group id="private_notes">
                                <tiny-mce
                                    :preview_mode="true"
                                    :height="400"
                                    :block_title="'Note Interne'"
                                    :initial_value="this.private_notes"
                                    @input="(value) => {
                                        this.private_notes = value
                                        this.update_private_data()
                                    }"
                                />
                            </b-form-group>
                        </div>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import TinyMce from '@/components/blocks/tiny-mce'
import ServiceSupplierPriceDetails from '@/components/blocks/service-supplier-price-details'
export default {
    name: 'private-data',
    components: {
        'tiny-mce': TinyMce,
        'service-supplier-price-details': ServiceSupplierPriceDetails,
    },
    props: {
        private_data: {
            type: Object,
            default: () => {}
        },
        service_index: Number,
    },
    data() {
        return {
            supplier: this.private_data.supplier,
            supplier_quote_id: this.private_data.supplier_quote_id,
            supplier_price: this.private_data.supplier_price,
            private_notes: this.private_data.private_notes,
            supplier_price_details: this.private_data.supplier_price_details ? this.private_data.supplier_price_details : [],
        }
    },
    created()
    {
    },
    mounted() {
    },
    methods:{
        update_private_data()
        {
            this.$store.commit('set_service_private_data', {
                service_index: this.service_index,
                private_data: {
                    supplier_price: this.supplier_price,
                    supplier: this.supplier,
                    supplier_quote_id: this.supplier_quote_id,
                    private_notes: this.private_notes,
                    supplier_price_details: this.supplier_price_details,
                },
            })
        },
    },
    computed: {
    }
}
</script>

<style lang="scss">
    .private-data
    {
        //@extend .service--common--block !optional;
        &--notes
        {
        }
        &--price
        {
        }
        &--supplier
        {
        }
        &--supplier-quote-id
        {
        }
    }
</style>